// exclude-from-index
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table, Text } from '@custom-components';
import { ProfilePic, AutoAvatar, ProfileContainer, UserInfo, CardTitle, CardDetails } from './PrimaryContact.styles';
import { phoneFormatted } from '../../../lib/utils';

class PrimaryContact extends PureComponent {
  static propTypes = {
    users: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  };

  renderRows() {
    const { users } = this.props;

    if (!users) return null;

    return users.map((member) => {
      const { id, firstName, lastName, profilePicture, emailAddress, phone, userType, roles } = member;
      let initials = '??';

      if (firstName && lastName && firstName.length > 0 && lastName.length > 0) {
        initials = `${firstName.slice(0, 1)}${lastName.slice(0, 1)}`;
      } else if (firstName && !lastName && firstName.length > 0) {
        initials = `${firstName.slice(0, 1)}`;
      } else if (lastName && !firstName && lastName.length > 0) {
        initials = `${lastName.slice(0, 1)}`;
      }
      return {
        id,
        name: (
          <ProfileContainer>
            <ProfilePic>
              <AutoAvatar src={profilePicture} initials={initials} alt={`${firstName} ${lastName}`} />
            </ProfilePic>
            <UserInfo>
              <CardTitle>
                {firstName} {lastName}
                <CardDetails>{userType}</CardDetails>
              </CardTitle>
            </UserInfo>
          </ProfileContainer>
        ),
        contactInfo: (
          <div>
            <Text.CopyParagraph tagName="span">{emailAddress}</Text.CopyParagraph>
            <br />
            <Text.CopyParagraph tagName="span">{phone ? phoneFormatted(phone) : ''}</Text.CopyParagraph>
          </div>
        ),
        roles: <Text.CopyParagraph>{roles}</Text.CopyParagraph>
      };
    });
  }

  render() {
    return (
      <Table
        minTableWidth="100%"
        rows={[
          { id: 'name', label: 'Name' },
          { id: 'contactInfo', label: 'Contact Info' },
          { id: 'roles', label: 'Roles' }
        ]}
      >
        {this.renderRows()}
      </Table>
    );
  }
}

export default PrimaryContact;
